// extracted by mini-css-extract-plugin
export default {"container":"styles_container__2C2fc","title":"styles_title__7Bv5T","containerMax":"styles_containerMax__gVlFO"};